import { useAutosave } from '@/hooks/useAutosave';
import { useSaveMission } from '@/hooks/useMissions';
import { useSaveRocket } from '@/hooks/useRockets';
import { useMissionStore } from '@/stores/missionStore';
import { useRocketStore } from '@/stores/rocketStore';
import { useSettingsStore } from '@/stores/settingsStore';

/**
 * Renders nothing — exists purely to run the two `useAutosave` subscriptions
 * at the shell root, so the mission and rocket documents keep saving no
 * matter which editor panel is currently open or closed.
 */
export function AutosaveController() {
  const autosaveEnabled = useSettingsStore((state) => state.autosaveEnabled);
  const saveMission = useSaveMission();
  const saveRocket = useSaveRocket();

  useAutosave({ store: useMissionStore, save: (input) => saveMission.mutateAsync(input), enabled: autosaveEnabled });
  useAutosave({ store: useRocketStore, save: (input) => saveRocket.mutateAsync(input), enabled: autosaveEnabled });

  return null;
}
